<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
					<i class="el-icon-arrow-left"></i> 
						批量添加证书
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="purchasesee-box">
			<p class="purchasesee-title">
				样例下载
			</p>
			<div class="purchasesee-padding">
				<el-button
				    type="primary"
				    icon="el-icon-download"
				    @click="downloadfun"
				>下载解压</el-button>
				
			</div>
			
			
			<p class="purchasesee-title" style="border-left: none;">
			</p>
			
			<p class="purchasesee-title">
				上传
			</p>
			
			
			<div class="purchasesee-padding upload-header-box">
				<!-- <el-upload
					class="upload"
					ref="upload"
					action="string"
					:file-list="fileList"
					:auto-upload="false"
					:http-request="uploadFile"
					:on-change="handleChange"
					:on-preview="handlePreview"
					:on-remove="handleRemove"
					multiple="multiple"
				  >
					<el-button slot="trigger" size="small" type="primary" @click="delFile">选取文件</el-button>
					<el-button
					  style="margin-left: 10px;"
					  size="small"
					  type="success"
					  @click="submitUpload"
					>上传到服务器</el-button>
				  </el-upload> -->
				
				
				<!-- <el-upload
				  
				  action="https://jsonplaceholder.typicode.com/posts/"
				  :on-change="handleChange"
				  :file-list="fileList">
				  <el-button size="small" type="primary">点击上传</el-button>
				  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
				</el-upload> -->
				
				<!-- <el-form>
					
					
				</el-form> -->
				
				<el-upload
					class="upload-demo upload-header"
					ref="upload"
					:file-list="fileList"
					:show-file-list="false"
					action="#"
					:http-request="uploadFile"
					:before-upload="beforeUploadFile"
					:auto-upload="true"
				  >
				  <input type="text" class="upload-inputval" v-model="fileval" placeholder="未选择文件">
					<el-button slot="trigger" size="small" type="primary">选取文件(zip)</el-button>
					
				  </el-upload>
				<el-button
				  style="margin-top: 10px;"
				  size="small"
				  type="primary"
				  @click="uploadFileSave"
				>保存</el-button>
				
			</div>
			
			
			
			
			
		</div>
        
		
		
    </div>
</template>

<script>
import {getLicenseApply,examineOrganizationLicenseApply} from '@/api/index';
export default {
    name: 'addbatchcer',
    data() {
        return {
			fileList:[],
			fileval:'',
			formDatafile:{}
        };
    },
    created() {
		
    },
    methods: {
	// 下载
	  // 列表导出Excel数据
	  downloadfun(){
	  	//console.log('/api/psOrganizationLicenseApply/exportExcelOrganizationLicenseApply'+par)
	  	window.open(
	  		  '/api/ctCertificateApply/exportExcelCertificateApply','_self'
	  		);
	  },
	  
	   // 确认上传
	      submitUpload() {
	        this.$refs.upload.submit();
	      },
	      // 文件上传
	      uploadFile(item) {
			  this.fileval = item.file.name;
			  console.log(this.fileval)
			   const _file = item.file;
			   var formData = new FormData();
			   formData.append("file", _file);
			   this.formDatafile = formData;
		  },
		  uploadFileSave(){
			  let token = localStorage.getItem('Authorization');
			  this.$http({
					method:'post',
					headers: { 'Content-Type': 'multipart/form-data',
						"Authorization":token
					},
					url:"/api/ctCertificateApply/uploadExcelCertificateApply",
					data:this.formDatafile,
					crossDomain:true,
					cache:false
			  }).then(res => {
				   console.log(res)
				   if(res.data.code == 0){
					   this.fileval =  res.data.message;
					   this.$message({
							  type: "success",
							  message: res.data.message
						});
				   }else {
					   this.$message({
						  type: "error",
						  message: res.data.message
						});
				   }
			  				// this.imageUrl = res.data.data[0];
			  }).catch(() => {
			  				 this.$message.error('上传失败，请重新上传')
			  })
		  },
		  beforeUploadFile(file) {
		        const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
		        const supportExtension = ["zip"];
		        // const isLt5M = file.size / 1024 / 1024 < 5;
		          if (!supportExtension.includes(extension)) {
					  this.$message({
						  type: "warning",
						  message: '请选择zip文件!'
					   });
					return false;
		          }
		        //   if (!isLt5M) {
				// 	  this.$message({
				// 		  type: "warning",
				// 		  message: '上传文件大小不能超过 5MB!'
				// 	   });
				// 	return false;
		        //   }
		  
		      
		      },
	  
    }
};

</script>

<style scoped>
.purchasesee-box{
	background: #fff;
	padding: 20px 0;
}
.purchasesee-title{
	height: 30px;
	line-height: 30px;
	 background: #F0F0F0;
	 font-size: 16px;
	 font-weight: 600;
	 letter-spacing: 2px;
	 border-left: 5px solid #437AF4;
	 text-indent: 30px;
}
.purchasesee-padding{
	padding:20px 35px;
}
.seelicense-item1{
	display: flex;
	display: -webkit-flex;
	padding: 0 35px;
	list-style: none;
	color: #666;
	letter-spacing: 1px;
}
.seelicense-item1 li{
	width: 200px;
	margin-right: 20px;
}
.seelicense-item1 li:last-child{
	flex:1;
}
.seelicense-item2{
	padding: 0 35px;
	margin-top: 15px;
	color: #666;
	letter-spacing: 1px;
}
.seelicense-item3{
	display: flex;
	display: -webkit-flex;
	padding: 0 35px;
	list-style: none;
	color: #666;
	letter-spacing: 1px;
	margin-bottom: 10px;
}
.seelicense-item3 li{
	width: 350px;
}
.seelicense-item4 {
	margin: 0 35px;
	background: #F8F8FB;
	padding: 20px;
	list-style: none;
	color: #666;
	letter-spacing: 1px;
}
.seelicense-item4 li{
	margin-bottom: 10px;
}

.purchasesee-text1,
.purchasesee-text2{
	height: 32px;
	line-height: 32px;
	text-indent: 15px;
}

.purchasesee-text2{
	text-indent: 50px;
}
.purchasesee-table{
	width: 50%;
	margin: 10px 0 30px 50px;
}
.purchasesee-linceinfo{
	margin: 10px 50px;
	display: flex;
	display: -webkit-flex;
	
}
.purchasesee-linceitem{
	width: 30%;
}
.purchasesee-linceitem:nth-child(2){
	margin:0 3%;
}
	
.organ-box {
    margin-bottom: 20px;
	text-align: right;
}
.apply-box{
	display: flex;
	display: -webkit-flex;
}
.apply-box p{
	flex:1;
}

.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

</style>
<style>
	.upload-header .el-upload-list{
		border: 1px solid #ddd;
		height: 40px;
		line-height: 40px;
		width: 260px;
		position: relative;
		top: -60px;
	}
	.upload-header .el-upload--text{
		border: 0;
		height: 40px;
		line-height: 40px;
		position: relative;
		
	}
	.upload-header-box{
		position: relative;
	}
	.upload-header-box  input{
		position: absolute;
		width: 260px;
		left: 30px;
		height: 32px;
		line-height: 32px;
	}
	.upload-header .el-upload--text button{
		position: absolute;
		right: 0;
		/* top: 10px; */
		top: 2px;
	}
</style>